import { createAction, props } from "@ngrx/store";
import { ParameterGroup } from "../../models/parameter-group";

export const findParameterGroupAct = createAction('findParameterGroupEffect', props<{ id: number }>());
export const loadParameterGroupByIdAct = createAction('loadParameterGroupByIdEffect', props<{ parameterGroup: ParameterGroup }>());
